<!-- eslint-disable vue/multi-word-component-names -->
<template>
  <v-col class="right-container">
    <Header
      v-if="props.role"
      :role="props.role"
      @reload="reload"
      @save="handleSave"
    />
    <v-row class="subheader">{{ $t('access.user_role.permissions.title') }}</v-row>
    <div class="permissions-wrapper">
      <PermissionsList
        :permissions="getPermissionsFeatures"
        :role="props.role"
        :edition="getEdition"
        :reload="needReload"
        @reloaded="needReload = false"
        @draftUpdated="permissions = $event"
      />
    </div>
  </v-col>
</template>
<script setup lang="ts">
import useStore from '@/utils/store/common';
import { computed, onMounted, ref } from 'vue';
import Header from './components/Header/Header.vue';
import PermissionsList from './components/PermissionsList/PermissionsList.vue';

const props = defineProps({
  role: {
    type: Object,
    default: () => ({})
  }
});

const emit = defineEmits(['save']);

const needReload = ref(false);

const permissions = ref([]);

const store = useStore();

const getPermissionsFeatures = computed(() => store.getters['userRoles/getPermissionsFeatures']);

const getEdition = computed(() => store.getters['userRoles/getEdition']);

onMounted(() => {
  store.dispatch('userRoles/fetchPermissionsFeatures');
});

function reload() {
  needReload.value = true;
}

function handleSave(event: any) {
  const dataToSend = event;
  dataToSend.permissions = permissions.value;
  store.dispatch('userRoles/updatePermissionsFeaturesOfRole', dataToSend).then(() => {
    emit('save', dataToSend);
  });
}
</script>
<style lang="scss" scoped>
@import './styles/right.scss';
</style>
